// auth.interceptor.ts
import { Injectable, Injector, inject } from '@angular/core';
import {
  HttpInterceptor, HttpRequest, HttpHandler, HttpEvent
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { AuthService } from './auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  // مافي dependency على AuthService هون
  private injector = inject(Injector);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url.startsWith(environment.apiBase)) {
      // مطلوب لقبول Set-Cookie من السيرفر (مثلاً POST /account/login) عندما الواجهة http://52395 والـ API https://5002
      const auth = this.injector.get(AuthService);
      const token = auth?.accessToken;
      if (token) {
        req = req.clone({
          withCredentials: true,
          setHeaders: { Authorization: `Bearer ${token}` },
        });
      } else {
        req = req.clone({ withCredentials: true });
      }
    }
    return next.handle(req);
  }
}
